import { API } from './api';

interface InfoStore {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface Params {
  token?: string;
  [key: string]: any;
}

class InfoService extends API {
  constructor(store?: InfoStore, params?: Params, id?: string | number) {
    super(store, params, id);
  }

  override generateUrl(): string {
    const lang = (this.store as InfoStore)?.lang || 'da';
    return ['channel/', lang, '/', this.id].join('');
  }

  async getInfoPage(): Promise<any> {
    return await this.fetchData();
  }
}

export default InfoService;
export { InfoService };
